<template>
  <!--
    v-if="dataReady" -->
  <div class="app-container store-container">
    <p class="name-container">
      <span class="hello">您好</span>
      <span class="user-name">{{ accountInfo.nickname }}</span>
      <span class="role">{{ role }}</span>
    </p>
    <div class="search-container">
      <span class="iconfont location-icon">&#xe664;</span>
      <div class="location-wrap">
        <el-cascader v-model="location" :options="areaOptions" :show-all-levels="false" :props="{ checkStrictly: true }" class="location-select" popper-class="location-popper"></el-cascader>
      </div>
      <div class="line"></div>
      <div class="location-wrap">
        <el-select v-model="currProgramType" placeholder="门店类型" class="pt-select" popper-class="pt-select-item">
          <el-option v-for="item in programTypeOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="line"></div>
      <el-input v-model.trim="searchVal" class="search-input" type="text" autocomplete="off" placeholder="输入门店号或名称" clearable></el-input>

      <el-button type="primary" class="search-btn" icon="el-icon-search" @click="searchData"></el-button>

    </div>
    <p>
      <span class="store-title">请选择一家门店进入</span><span class="store-ask" @click="storeAsk">有门店不在列表中？</span>
    </p>

    <ul class="store-list-wrap flex-between">
      <li v-for="item in list" :key="item.customerNumber" @click="login(item)">
        <div v-show="item" class="store-item flex-center-between" :class="Constant.tp_list.indexOf(item.programType) > -1 ? 'tp' : 'nt'">
          <div class="left-wrap">
            <p class="store-num one_txt_cut">{{ item.customerNumber }} {{ item.programType }}</p>
            <p class="store-name one_txt_cut">{{ item.customerName }}</p>
          </div>
          <i class="el-icon-arrow-right right-icon" />
        </div>
      </li>

      <li v-show="!list.length && noMore" class="empty-wrap">
        <img src="../assets/img/icon-empty.png" class="empty" alt="">
        <p class="empty-txt">暂无数据</p>
      </li>
    </ul>
  </div>
</template>

<script>
// import axios from 'axios'
// import indexDB from '@/mixin/indexDB'
import staticInfo from '@/helpers/staticInfo'
import { SessionStorage } from '@/helpers/storage'
import Constant from '../utils/constant'

export default {
  name: 'Stores',
  // mixins: [indexDB],
  data() {
    return {
      loadingComponent: null,
      isLoading: false,
      searchVal: '',
      location: [''],
      areaOptions: [],
      currProgramType: '',
      programTypeOptions: [],
      dataReady: false,
      list: [],
      pcTriggerUpScroll: false,
      oldOffsetBottom: 0,
      currPage: 1,
      limit: 24,
      noMore: false,
      allDataList: [],
      filterDataList: []
    }
  },
  computed: {
    Constant() {
      return Constant
    },
    accountInfo() {
      return this.$store.getters.accountInfo
    },
    role() {
      return this.$store.getters.roleList[0].roleName
    },
    customerConditionType() {
      return this.$store.getters.customerConditionType
    },
    manageArea() {
      return this.$store.getters.manageArea
    },
    programTypeList() {
      return this.$store.getters.programTypeList
    },
    agreements() {
      return this.$store.getters.agreements
    }
    // storeList() {
    //   const list = this.$store.getters.storesList
    //   // 补余
    //   const index = list.length % 3
    //   if (index !== 0) {
    //     for (let i = 0; i < 3 - index; i++) {
    //       list.push('')
    //     }
    //   }

    //   return list
    // }
  },
  watch: {
    isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: '',
          spinner: 'cricle_loader',
          background: 'rgba(255, 255, 255, 0)'
        })
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close()
        }
      }
    },
    searchVal(val) {
      // this.filterStores(this.location, val)
    },
    location(val) {
      console.log(val)
      // this.filterStores(val, this.searchVal)
    }
    // myDB(val) {
    //   if (val && this.isIndexDBEnable) { // 支持indexDB
    //     // 先读取部分数据
    //     // this.getFewIndexDBData()
    //     // 同时获取所有的数据
    //     this.isLoading = true
    //     this.readAllIndexDB('customers')
    //   } else {
    //     this.allDataList = this.storeList
    //     this.filterDataList = this.storeList
    //     this.list = this.storeList.slice(this.currPage - 1, this.limit)
    //     this.dataReady = true
    //   }
    // },
    // readAllFlag(val) {
    //   if (val) {
    //     const tmp = this.indexDBResultList
    //     // 补余
    //     const index = tmp.length % 3
    //     if (index !== 0) {
    //       for (let i = 0; i < 3 - index; i++) {
    //         tmp.push('')
    //       }
    //     }
    //     this.allDataList = tmp
    //     this.filterDataList = tmp
    //     this.list = this.filterDataList.slice(this.currPage - 1, this.limit)
    //     this.dataReady = true

    //     this.isLoading = false
    //   }
    // }
  },
  mounted() {
    console.log('store----mounted---')
    this.fetchData()

    this.areaOptions = this.formatterArea(this.manageArea)
    console.log('this.areaOptions---', this.areaOptions)

    this.programTypeOptions = this.formatterProgramType(this.programTypeList)

    this.setTheme()

    // for (let i = 0; i <= 300; i++) {
    //   this.filterDataList.push({
    //     customerNumber: i,
    //     customerName: i,
    //     programType: 'TYREPLUS'
    //   })
    // }
    // this.fetchMore()
  },
  activated() {
    console.log('store----activated---')
    document.getElementById('app').addEventListener('scroll', this.handleScroll)
    this.setTheme()
  },
  deactivated() {
    document.getElementById('app').removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll(e) {
      const offsetBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight
      const direction = offsetBottom - this.oldOffsetBottom
      this.oldOffsetBottom = offsetBottom
      if (offsetBottom < 600 && this.pcTriggerUpScroll && direction < 0 && !this.noMore) {
        console.log('///llll/////')
        this.currPage++
        // this.fetchMore()
        this.fetchData()
      }
    },
    setTheme() {
      const theme = 'nt'
      window.document.documentElement.setAttribute('data-theme', theme)
      SessionStorage.setItem('data-theme', theme)
      this.$store.dispatch('apps/SET_THEME', theme)
    },
    formatterArea(val) {
      val.forEach(item => {
        item['value'] = item.code
        item['label'] = item.name || item.val

        if (item.children && item.children.length) {
          // 删除子集全部选项
          if (item.children[0] && !item.children[0].code) {
            item.children.splice(0, 1)
          }
          this.formatterArea(item.children)
        } else {
          delete item.children
        }
      })

      return val
    },
    formatterProgramType(val) {
      const tmp = val.map(item => {
        return {
          'value': item,
          'label': item
        }
      })
      tmp.unshift({
        'value': '',
        'label': '门店类型'
      })
      return tmp
    },
    filterStores(location, searchVal) {
      const provinceCode = location[0]
      const cityCode = location[1]

      this.currPage = 1
      this.filterDataList = []

      this.filterDataList = this.allDataList

      this.filterDataList = this.filterDataList.filter(data => {
        if (!provinceCode) {
          return true
        }

        if (!cityCode) {
          return data.provinceCode === provinceCode || data.consultantOffice === provinceCode || data.salesOffice === provinceCode
        } else {
          return data.cityCode === cityCode || data.salesTerritory === cityCode || data.consultantTerritory === cityCode
        }
      })

      this.filterDataList = this.filterDataList.filter(data => {
        return !searchVal || !data.customerName || !data.customerNumber ||
          data.customerName.indexOf(searchVal) !== -1 || data.customerNumber.indexOf(searchVal) !== -1
      })

      // 补余
      const index = this.filterDataList.length % 3
      if (index !== 0) {
        for (let i = 0; i < 6 - index; i++) {
          this.filterDataList.push('')
        }
      }

      this.list = this.filterDataList.slice(this.currPage - 1, this.limit)
    },
    storeAsk() {
      this.gtag('event', 'tips_store_not_in_list')

      const h = this.$createElement
      this.$msgbox({
        title: '有门店不在列表',
        message: h('p', { style: 'text-align: justify' }, [
          h('span', null, '如果在门店列表中找不到您的门店编号，您可以拨打咨询：'),
          h('br', null, ''),
          h('i', { class: 'point' }, `${staticInfo.NT.Tel_HotLine}（米其林）`),
          h('span', { class: 'point' }, '/ '),
          h('i', { class: 'point' }, `${staticInfo.TP.Tel_HotLine}（驰加）`),
          h('br', null, ''),
          h('span', null, '请您提供当前用于登录系统的手机号，以及无法找到的门店编号，客服会在问题解决后第一时间回复您')
        ]),
        showCancelButton: false,
        center: true,
        customClass: 'dcp-message-box',
        confirmButtonClass: 'dcp-message-box-confirm-btn'
      }).then(action => { })
    },
    login(val) {
      if (!val) return
      this.isLoading = true
      this.$api.login.getCustomerApps(val.customerNumber)
        .then(res => {
          this.isLoading = false
          // 区分登录账号主题
          const theme = Constant.tp_list.indexOf(val.programType) > -1 ? 'tp' : 'nt'
          window.document.documentElement.setAttribute('data-theme', theme)
          SessionStorage.setItem('data-theme', theme)
          this.$store.dispatch('apps/SET_THEME', theme)

          this.$store.dispatch('apps/SET_CURR_CUSTOMER', res.data.currCustomer || {})
          this.$store.dispatch('apps/SET_CURR_ROLES', res.data.currDcpRoles || [])
          this.$store.dispatch('apps/SET_CURR_APPS', res.data.currApps || {})

          this.$nextTick(() => {
            this.$router.push({ path: '/index', query: { type: 'first' }})
          })
        }).catch(() => {
          this.isLoading = false
        })
    },
    fetchMore() {
      // console.log(e)
      if (this.currPage === 1) this.list = []
      this.noMore = true
      let tmp = []
      const index = (this.currPage - 1) * this.limit
      tmp = this.filterDataList.slice(index, index + this.limit)

      // console.log(this.filterDataList.length, tmp.length, index)
      this.list = this.list.concat(tmp)
      // console.log('tmp----', tmp.length, this.list.length)

      setTimeout(() => {
        this.noMore = false
      }, 600)
    },
    searchData() {
      this.currPage = 1
      this.fetchData()
    },
    fetchData() {
      // if (this.sourceApi) {
      //   this.sourceApi.cancel('cancel')
      // }
      // this.sourceApi = axios.CancelToken.source()

      const location1 = this.location[0] || ''
      const location2 = this.location[1] || ''

      const tmp = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: {
          customerName: this.searchVal,
          customerNumber: this.searchVal,
          programType: this.currProgramType,
          provinceCode: this.customerConditionType === 'OTHER_ROLE' ? location1 : '',
          cityCode: this.customerConditionType === 'OTHER_ROLE' ? location2 : '',
          consultantOffice: this.customerConditionType === 'CONSULATANT_ROLE' ? location1 : '',
          consultantTerritory: this.customerConditionType === 'CONSULATANT_ROLE' ? location2 : '',
          salesOffice: this.customerConditionType === 'SALES_ROLE' ? location1 : '',
          salesTerritory: this.customerConditionType === 'SALES_ROLE' ? location2 : ''
        }
      }

      this.pcTriggerUpScroll = false
      this.noMore = false
      if (this.currPage <= 1) { this.list = [] }

      this.isLoading = true
      this.$api.login.getUserCustomers(tmp).then(res => {
        const tmpData = res.data.items || []
        if (this.currPage === 1) {
          this.list = tmpData
        } else {
          this.list = this.list.concat(tmpData)
        }
        console.log('tmpData---', tmpData.length, tmpData.length < this.limit)
        if (tmpData.length < this.limit) {
          this.noMore = true
          // 补余
          const index = this.list.length % 3
          if (index !== 0) {
            for (let i = 0; i < 3 - index; i++) {
              this.list.push('')
            }
          }
        }

        this.isLoading = false
        // 数据渲染成功后,隐藏下拉刷新的状态
        this.$nextTick(() => {
          this.pcTriggerUpScroll = true
        })
      }).catch(() => {
        // if (axios.isCancel(err)) {
        //   return false
        // }

        this.pcTriggerUpScroll = true
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.store-container {
  @include color_page_primary('color');
}

.name-container {
  display: flex;
  align-items: baseline;
  margin-top: 20px;

  .hello {
    font-weight: 500;
    font-size: 40px;
  }

  .user-name {
    margin-right: 10px;
    margin-left: 21px;
    font-size: 32px;
  }

  .role {
    padding: 2px 6px;
    // margin-top: 2px;
    margin-left: 4px;
    border-radius: 4px;
    font-size: 14px;
    color: #906425;
    background-color: $color-yellow;
  }
}

.search-container {
  display: flex;
  align-items: center;
  height: 53px;
  padding-left: 17px;
  margin-top: 22px;
  margin-bottom: 41px;
  border-radius: 27px;
  overflow: hidden;

  .location-icon {
    font-size: 18px;
  }

  .location-wrap {
    font-weight: 600;
    font-size: 18px;

    .location-select,
    .pt-select {
      /deep/ &.el-cascader {
        width: auto;

        .el-input__suffix {
          display: none;
        }
      }

      /deep/.el-input__inner {
        padding-right: 0;
        // width: 120px;
        // padding: 0 10px;
        border: none;
        background: transparent;

        &::placeholder {
          @include color_page_primary('color');
        }

        &::-webkit-input-placeholder {
          /* WebKit browsers 适配谷歌 */
          @include color_page_primary('color');
        }

        &:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 适配火狐 */
          @include color_page_primary('color');
        }

        &::-moz-placeholder {
          /* Mozilla Firefox 19+ 适配火狐 */
          @include color_page_primary('color');
        }

        &:-ms-input-placeholder {
          /* Internet Explorer 10+  适配ie */
          @include color_page_primary('color');
        }

        @include color_page_primary('color');
      }
    }
  }

  .line {
    width: 2px;
    height: 26px;
    margin: 0 10px;

    @include background_color_page_primary('color');
  }

  .search-input {
    // flex: 1;
    flex-grow: 1;
    font-size: 18px;
    // height: 100%;
    // border-left: 2px solid #e4ebf7;

    // 更改clear图标
    /deep/.el-input__suffix {
      .el-icon-circle-close {
        font-size: 20px;

        &::before {
          content: '\e6db';
        }

        @include color_page_primary('color');
      }
    }

    /deep/.el-input__inner {
      // height: 100%;
      padding-left: 10px;
      border: none;
      background: transparent;

      &::placeholder {
        // @include color_page_primary('color');
      }

      &::-webkit-input-placeholder {
        /* WebKit browsers 适配谷歌 */
        // @include color_page_primary('color');
      }

      &:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 适配火狐 */
        // @include color_page_primary('color');
      }

      &::-moz-placeholder {
        /* Mozilla Firefox 19+ 适配火狐 */
        // @include color_page_primary('color');
      }

      &:-ms-input-placeholder {
        /* Internet Explorer 10+  适配ie */
        // @include color_page_primary('color');
      }

      @include color_page_primary('color');
    }

    @include border_color_page_primary('color');
  }

  .search-btn {
    width: 80px;
    height: 53px;
    border-radius: 27px;
    font-size: $fontSizeLarge;

    @include btn_page_primary('color');
  }

  @include background_color_page_primary('bg-color-light');
  @include color_page_primary('color');
}

.pt-select-item {
  .el-select-dropdown__item {
    &.selected,
    &.is-selected {
      @include color_page_primary('color');
    }
  }
}

.store-title {
  font-weight: 600;
  font-size: 24px;
  line-height: 48px;
  color: #000;
}

.store-ask {
  float: right;
  font-weight: 500;
  font-size: 18px;
  line-height: 48px;
  cursor: pointer;
}

.store-list-wrap {
  flex-wrap: wrap;
  padding: 30px 0;

  li {
    width: 384px;
    // height: 77px;
    // margin-bottom: calc((100% - 384px*3) / 2);

    margin-bottom: calc((#{$pageInnerWidth} - 384px * 3) / 2);
  }

  .store-item {
    width: 100%;
    height: 77px;
    padding: 0 16px;
    border-radius: 4px;
    cursor: pointer;

    &.tp {
      color: #444;
      background-color: $color-green-lighter;
    }

    &.nt {
      color: $color-blue;
      background-color: $color-blue-lighter;
    }

    .left-wrap {
      // flex: 1;
      flex-grow: 1;
      width: 0;

      .store-num {
        margin-bottom: 4px;
        font-weight: 600;
        font-size: 18px;
      }

      .store-name {
        font-size: 16px;
      }
    }

    .right-icon {
      width: 40px;
      font-size: 24px;
      text-align: right;
    }
  }

  .empty-wrap {
    width: 100% !important;
    text-align: center;

    .empty {
      width: auto;
      height: 160px;
      margin: 30px auto 0;
    }

    .empty-txt {
      margin-top: 8px;
      font-size: $fontSizeBase;
      color: #c0c4cc;
    }
  }
}
</style>
